"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setChildrenAction = (_a = createFeature_1.createInputFeature('children'), _a.actionCreator), exports.childrenSelector = _a.selectorCreator, exports.ChildrenFeature = _a.featureReducer;
//# sourceMappingURL=children.js.map